import { useContext } from "react";
import { AuthContext } from "./../contexts/AuthContext";


export const useUserData = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useUserData must be used within a UserDataProvider');
  }
  return context;
};